module.exports = __webpack_public_path__ + "img/fees1.118f3b3f.jpg";